import styled from 'styled-components';

export const Wrapper = styled.span`
    span {
        margin: 0 0.2rem;
    }
`;
